import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
//
import TemplateHome from "../components/TemplateHome";

//
const NotFound = () => (
  // store

  // local

  <TemplateHome>
    <Grid container justifyContent="center">
      <Grid item>
        <Box pt={5}>
          <Typography variant="h5">
            The requested URL was not found on this server.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </TemplateHome>
);

export default NotFound;
